import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Modal, CircularProgress } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom"; // Importar useLocation para obtener la URL
import { useTheme } from "@mui/material/styles";
import { handlePagoEvent, showLoadingSpinner } from "../helpers/pagosHelper";
import DebitoIcon from "../images/debito.png";
import EfectivoPagoIcon from "../images/efectivo-icon.png";
import CreditoIcon from "../images/credito.png";
import qr from "../images/qr.png";
import qrImage from "../images/qr-pago.png";
import MenuSection from "../components/MenuSection";
import estadoDespacho from "../api/estadoDespacho";
import DividirPagoIcon from "../images/icono-cajero.png";
import ConsultarSaldoShellBox from "../api/consultarSaldoShellBox";
import { useCanjeStore } from "../hooks";

const FormasDePagoPage = () => {
  const navigate = useNavigate();
  const esDUO = JSON.parse(localStorage.getItem("esDUO")) || false;
  const location = useLocation(); // Hook para obtener los parámetros de la URL
  const [isLoading, setIsLoading] = useState(false);
  const [mensajeDeEspera, setMensajeDeEspera] = useState("");
  const [showPuntosModal, setShowPuntosModal] = useState(false);
  const [isCheckingPoints, setIsCheckingPoints] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrType, setQRType] = useState(""); // Nuevo estado para identificar el tipo de QR
  const theme = useTheme();
  const bandera = localStorage.getItem("bandera");
  const listadoQR = localStorage.getItem("conListadoQR");
  const { premio, dniCanje } = useCanjeStore();

  const DURACION_ESPERA_PAGO = 3000; // 3 segundos
  const DURACION_PROCESAMIENTO_PAGO = 1500; // 1.5 segundos

  const handleEfectivoEvent = async event => {
    const responsePagoEfectivoJava = event.detail.success;
    localStorage.setItem("responsePagoEfectivoJava", responsePagoEfectivoJava);

    if (responsePagoEfectivoJava) {
      setIsLoading(true);

      const despachosSeleccionados = localStorage.getItem("despachosSeleccionados");

      if (despachosSeleccionados) {
        const despachosArray = JSON.parse(despachosSeleccionados); // Asegúrate de que sea un array
        try {
          // Usamos un bucle for...of para esperar cada despacho antes de navegar
          for (const despachoId of despachosArray) {
            await estadoDespacho.actualizarDespacho(despachoId, 1, 1);
          }
          navigate("/dialogoimprimirfacturapage");
        } catch (error) {
          console.error("Error al actualizar despacho:", error);
          // Manejar error si es necesario
        }
      } else {
        navigate("/dialogoimprimirfacturapage");
      }
    }
  };
  useEffect(() => {
    const eventListener = handlePagoEvent(setIsLoading, navigate);

    window.addEventListener("responsePagoConTarjeta", eventListener);
    window.addEventListener("responsePagoEfectivo", handleEfectivoEvent);

    return () => {
      window.removeEventListener("responsePagoConTarjeta", eventListener);
      window.removeEventListener("responsePagoEfectivo", handleEfectivoEvent);
    };
  }, []);

  // Ejecutar la función de pago automáticamente si se ha seleccionado una forma de pago en la URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search); // Obtener parámetros de la URL
    const medioDePago = searchParams.get("medioDePago"); // Extraer "medioDePago" de la URL

    if (medioDePago) {
      switch (medioDePago) {
        case "debito":
          handleDebito();
          break;
        case "credito":
          handleCredito();
          break;
        case "efectivo":
          handleCloverEfectivo();
          break;
        case "qr":
          handleDebito();
          break;
        default:
          break;
      }
    }
  }, [location]); // Ejecutar el efecto cuando cambie la ubicación (URL)
  const handleDebito = async () => {
    setMensajeDeEspera("ESPERANDO TARJETA...");

    setTimeout(() => {
      setMensajeDeEspera("");
      setIsLoading(true);

      setTimeout(async () => {
        const despachosSeleccionados = localStorage.getItem("despachosSeleccionados");

        if (despachosSeleccionados) {
          const despachosArray = JSON.parse(despachosSeleccionados);
          try {
            for (const despachoId of despachosArray) {
              await estadoDespacho.actualizarDespacho(despachoId, 1, 1);
            }
          } catch (error) {
            console.error("Error al actualizar despacho:", error);
            setIsLoading(false);
            return;
          }
        }

        navigate("/dialogoimprimirfacturapage");
      }, DURACION_PROCESAMIENTO_PAGO); // ← Duración personalizada
    }, DURACION_ESPERA_PAGO); // ← Duración personalizada
  };

  const handleCloverEfectivo = async () => {
    setMensajeDeEspera("ESPERANDO PAGO EN EFECTIVO...");
    localStorage.removeItem("CuponClover");

    setTimeout(() => {
      setMensajeDeEspera("");
      setIsLoading(true);

      setTimeout(async () => {
        const despachosSeleccionados = localStorage.getItem("despachosSeleccionados");

        if (despachosSeleccionados) {
          const despachosArray = JSON.parse(despachosSeleccionados);
          try {
            for (const despachoId of despachosArray) {
              await estadoDespacho.actualizarDespacho(despachoId, 1, 1);
            }
          } catch (error) {
            console.error("Error al actualizar despacho:", error);
            setIsLoading(false);
            return;
          }
        }

        navigate("/dialogoimprimirfacturapage");
      }, DURACION_PROCESAMIENTO_PAGO);
    }, DURACION_ESPERA_PAGO);
  };

  const handleCredito = () => {
    navigate("/cuotaspage");
  };

  const handleQR = () => {
    if (listadoQR == "true") {
      navigate("/listadoqrpage");
    } else if (listadoQR == "false") {
      navigate("/pagoqrpage");
    } else {
      navigate("/listadoqrpage");
    }
  };

  const handleQRFiserv = () => {
    // Mostrar la pantalla del QR con el monto para FISERV
    setQRType("FISERV");
    setShowQRModal(true);

    // Después de 5 segundos, ocultar el QR y mostrar el modal de procesando pago
    setTimeout(() => {
      setShowQRModal(false);
      setIsLoading(true);

      // Simular el procesamiento del pago como las otras formas
      setTimeout(async () => {
        const despachosSeleccionados = localStorage.getItem("despachosSeleccionados");

        if (despachosSeleccionados) {
          const despachosArray = JSON.parse(despachosSeleccionados);
          try {
            // Usamos un bucle for...of para esperar cada despacho antes de navegar
            for (const despachoId of despachosArray) {
              await estadoDespacho.actualizarDespacho(despachoId, 1, 1);
            }
            navigate("/dialogoimprimirfacturapage");
          } catch (error) {
            console.error("Error al actualizar despacho:", error);
            setIsLoading(false);
          }
        } else {
          navigate("/dialogoimprimirfacturapage");
        }
      }, 3000); // 3 segundos adicionales para el procesamiento
    }, 5000); // 5 segundos para mostrar el QR
  };

  const handleQRYPF = () => {
    // Mostrar la pantalla del QR con el monto
    setQRType("YPF");
    setShowQRModal(true);

    // Después de 5 segundos, ocultar el QR y mostrar el modal de procesando pago
    setTimeout(() => {
      setShowQRModal(false);
      setIsLoading(true);

      // Simular el procesamiento del pago como las otras formas
      setTimeout(async () => {
        const despachosSeleccionados = localStorage.getItem("despachosSeleccionados");

        if (despachosSeleccionados) {
          const despachosArray = JSON.parse(despachosSeleccionados);
          try {
            // Usamos un bucle for...of para esperar cada despacho antes de navegar
            for (const despachoId of despachosArray) {
              await estadoDespacho.actualizarDespacho(despachoId, 1, 1);
            }
            navigate("/dialogoimprimirfacturapage");
          } catch (error) {
            console.error("Error al actualizar despacho:", error);
            setIsLoading(false);
          }
        } else {
          navigate("/dialogoimprimirfacturapage");
        }
      }, 3000); // 3 segundos adicionales para el procesamiento
    }, 5000); // 5 segundos para mostrar el QR
  };

  // Función para obtener el monto total de facturaInfo
  const obtenerMontoTotal = () => {
    try {
      const facturaInfo = localStorage.getItem("facturaInfo");
      if (facturaInfo) {
        const parsedInfo = JSON.parse(facturaInfo);
        return parsedInfo.total || "0.00";
      }
      return "0.00";
    } catch (error) {
      console.error("Error al obtener monto total:", error);
      return "0.00";
    }
  };

  // Función para manejar la elección de pago y verificar si se deben acumular puntos
  const handleEleccionPago = async (medioDePago, metodoPagoCallback) => {
    const bandera = localStorage.getItem("bandera");

    if (bandera === "shell") {
      let redimirSuccess = false;
      let acumulaSuccess = false;

      // Llamada a sugerirRedimirLatamPass
      try {
        const response = await ConsultarSaldoShellBox.sugerirRedimirLatamPass();
        console.log("sugerirRedimirLatamPass status:", response.status);
        redimirSuccess = response.status === 200;
      } catch (error) {
        // Si ocurre error (por ejemplo, status 500) lo marcamos como fallo
        console.error("Error en sugerirRedimirLatamPass:", error);
        redimirSuccess = false;
      }

      // Llamada a acumulaPuntos
      try {
        const responseAcumula = await ConsultarSaldoShellBox.acumulaPuntos();
        console.log("acumulaPuntos status:", responseAcumula.status);
        acumulaSuccess = responseAcumula.status === 200;
      } catch (error) {
        console.error("Error en acumulaPuntos:", error);
        acumulaSuccess = false;
      }

      // Si ambos endpoints fallan, se ejecuta el callback de método de pago
      if (!redimirSuccess && !acumulaSuccess) {
        return metodoPagoCallback();
      }

      // Se arma la URL con los parámetros según el resultado de cada llamada
      const queryParams = new URLSearchParams({ medioDePago });
      queryParams.append("sugerirRedimirLatamPass", redimirSuccess ? "true" : "false");
      queryParams.append("acumulaPuntos", acumulaSuccess ? "true" : "false");

      navigate(`/obtenerdnipuntos?${queryParams.toString()}`);
    } else {
      metodoPagoCallback();
    }
  };

  const handleDividirPago = () => {
    navigate("/dividirpagopage");
  };

  return (
    <>
      {/* SPINNER DE CARGA */}
      {isCheckingPoints && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "100vw",
            height: "65vh",
            bgcolor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      <MenuSection />
      {(isLoading || mensajeDeEspera) && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(255, 255, 255, 0.98)",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={80} />
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontWeight: "bold",
              color: "#333",
              fontSize: "1.2rem",
            }}
          >
            {mensajeDeEspera || "PROCESANDO PAGO..."}
          </Typography>
        </Box>
      )}

      {/* MODAL QR (YPF/FISERV) */}
      {showQRModal && (
        <Modal
          open={showQRModal}
          onClose={() => {}} // No permitir cerrar el modal
          aria-labelledby="qr-modal-title"
          aria-describedby="qr-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: window.innerWidth < 700 ? "90%" : "400px",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              textAlign: "center",
              outline: "none",
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                color: "#333",
                marginBottom: 2,
                fontSize: "1.2rem",
              }}
            >
              Escanea el QR para confirmar el pago, por favor espere...
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              <CircularProgress size={40} sx={{ color: "#1976d2" }} />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              <img
                src={qrImage}
                alt="QR Code"
                style={{
                  width: "200px",
                  height: "200px",
                }}
              />
            </Box>

            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                color: "#333",
                marginBottom: 3,
              }}
            >
              Monto: ${obtenerMontoTotal()}
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                fontWeight: "bold",
                padding: "12px 24px",
                fontSize: "1rem",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
              onClick={() => {
                setShowQRModal(false);
                setQRType("");
              }}
            >
              CANCELAR
            </Button>
          </Box>
        </Modal>
      )}

      <Box
        sx={{
          position: "absolute",
          top: window.innerWidth < 700 ? "8%" : "12%",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <h3
          style={{
            backgroundColor: theme.bandera.colorSecundario,
            color: "white",
            fontWeight: "bold",
            padding: "20px 22px",
            width: "100%",
            textAlign: "center",
            whiteSpace: "nowrap",
            margin: 0,
          }}
        >
          SELECCIONE UNA FORMA DE PAGO:
        </h3>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: window.innerWidth < 700 ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
            gap: "80px",
            alignItems: "center",
            mt: esDUO? 16 : 6,
          }}
        >
          <Button
            sx={{ width: esDUO? "100px" : "70px", height: esDUO? "100px" : "70px", display: "flex", flexDirection: "column", alignItems: "center" }}
            onClick={() => handleEleccionPago("debito", handleDebito)} // Primero verificamos si se acumulan puntos
          >
            <img src={DebitoIcon} alt="Debito" style={{ width: esDUO? "100px" : "70px" }} />
            <Typography width={"140px"} color="black" variant="subtitle2" fontWeight="bold" marginTop={0.5}>
              DÉBITO
            </Typography>
          </Button>

          <Button
            sx={{ width: esDUO? "100px" : "70px", height: esDUO? "100px" : "70px", display: "flex", flexDirection: "column", alignItems: "center" }}
            onClick={() => handleEleccionPago("credito", handleCredito)} // Primero verificamos si se acumulan puntos
          >
            <img src={CreditoIcon} alt="Credito" style={{ width: esDUO? "100px" : "70px" }} />
            <Typography width={"140px"} color="black" variant="subtitle2" fontWeight="bold" marginTop={0.5}>
              CRÉDITO
            </Typography>
          </Button>

          <Button
            sx={{ width: esDUO? "100px" : "70px", height: esDUO? "100px" : "70px", display: "flex", flexDirection: "column", alignItems: "center" }}
            onClick={() => handleEleccionPago("qr", handleQRFiserv)} // Cambio aquí: usar handleQRFiserv en lugar de handleDebito
          >
            <img src={qr} alt="QR FISERV" style={{ width: esDUO? "90px" : "60px" }} />
            <Typography width={"140px"} color="black" variant="subtitle2" fontWeight="bold" marginTop={0.5}>
              QR FISERV
            </Typography>
          </Button>

          <Button
            sx={{ width: esDUO? "100px" : "70px", height: esDUO? "100px" : "70px", display: "flex", flexDirection: "column", alignItems: "center" }}
            onClick={() => handleEleccionPago("efectivo", handleCloverEfectivo)} // Primero verificamos si se acumulan puntos
          >
            <img src={EfectivoPagoIcon} alt="Efectivo" style={{ width: esDUO? "90px" : "60px" }} />
            <Typography width={"140px"} color="black" variant="subtitle2" fontWeight="bold" marginTop={0.5}>
              EFECTIVO
            </Typography>
          </Button>

          {/* {(bandera === "ypf" || bandera === "shell") && ( */}
            <Button
              sx={{
                width: esDUO? "100px" : "70px",
                height: esDUO? "100px" : "70px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onClick={bandera === "ypf" ? handleQRYPF : handleQRFiserv}
            >
              <img src={theme.bandera.logoPago} alt="Clover" style={{ width: esDUO? "90px" : "60px" }} />
              <Typography width={"140px"} color="black" variant="subtitle2" fontWeight="bold" marginTop={0.5}>
                {theme.bandera.textoBotonPago}
              </Typography>
            </Button>
          {/* )} */}
          <Button
            sx={{ width: esDUO? "100px" : "70px", height: esDUO? "100px" : "70px", display: "flex", flexDirection: "column", alignItems: "center" }}
            onClick={() => handleEleccionPago("dividir", handleDividirPago)}
          >
            <img src={DividirPagoIcon} alt="Dividir Pago" style={{ width: esDUO? "90px" : "60px" }} />
            <Typography width={"140px"} color="black" variant="subtitle2" fontWeight="bold" marginTop={0.5}>
              DIVIDIR PAGO
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default FormasDePagoPage;
